import { Injectable } from '@angular/core';
import { SceneService } from '../services/index';
import * as THREE from 'three';
import { GLTF, GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';
@Injectable({
  providedIn: 'root',
})
export class ModelLoaderService {
  private _laneNames: string[] = [];
  private _loaderGLTF = new GLTFLoader();
  private _filledForkLiftModelSortArea: THREE.Group;
  private _filledForkLiftmodelLane: THREE.Group;
  private _filledForkLiftmodelExit: THREE.Group;
  private _monotainer: THREE.Group;
  private _mixer: THREE.AnimationMixer;
  private _models: THREE.Object3D[] = [];
  private _flag: boolean = false;
  private _laneXPos: number = -2.4;
  private _laneBulb: Map<string, any> = new Map<string, any>();
  private _res: any;
  private _billBoard: CSS3DObject;
  private _laneDetailsBillbord: CSS3DObject[] = [];
  private _laneBillboardPos: number = 4.7;
  private _modelPos:THREE.Vector3;
  private _laneName: CSS3DObject[] = [];
  constructor(
    private _sceneService: SceneService,
    public service: ServicecallService
  ) {
    this.service.getPlanogramData('default').subscribe((res: any) => {
      if (res?.length) {
        this._res = res;
        this.setLaneName(this._res)
      }
    });
  }

  /**
   * Sets factory model
   * @param position
   * @param scale
   * @param rotation
   * @returns factory model
   */
  setFactoryModel(
    position: THREE.Vector3,
    scale: THREE.Vector3,
    rotation: number
  ): Promise<void> {
    return new Promise((resolve) => {
      const scene = this._sceneService.getScene();
      this._loaderGLTF.load('assets/models/Scene2.glb', (glb: GLTF) => {
        const model = glb.scene;
        this._mixer = new THREE.AnimationMixer(model);
        this._mixer.clipAction(glb.animations[0]).play();
        model.position.copy(position);
        model.scale.copy(scale);
        model.rotateY(rotation);
        model.name = 'factoryGround';
        glb.scene.traverse(function (child) {
          if ((<THREE.Mesh>child).isMesh) {
            child.castShadow = true;
            child.receiveShadow = true;
          }
        });
        scene.add(model);
        this._modelPos=model.position;
        this._models.push(model);
        resolve();
      });
    });
  }

  /**
   * Sets model fork lift
   * @param position
   * @param scale
   * @param rotation
   * @returns model fork lift
   */
  setModelForkLift(
    position: THREE.Vector3,
    scale: THREE.Vector3,
    rotation: number
  ): Promise<void> {
    return new Promise((resolve) => {
      const scene = this._sceneService.getScene();
      this._loaderGLTF.load(
        'assets/models//filledForklift.glb',
        (glb: GLTF) => {
          this._filledForkLiftModelSortArea = glb.scene;
          this._filledForkLiftModelSortArea.position.copy(position);
          this._filledForkLiftModelSortArea.scale.copy(scale);
          this._filledForkLiftModelSortArea.rotateY(rotation);
          this._filledForkLiftModelSortArea.name = 'forkliftSort';
          glb.scene.traverse(function (child) {
            if ((<THREE.Mesh>child).isMesh) {
              child.castShadow = true;
              child.receiveShadow = true;
            }
          });
          scene.add(this._filledForkLiftModelSortArea);
          this._models.push(this._filledForkLiftModelSortArea);
        }
      );
      this._loaderGLTF.load(
        'assets/models//filledForklift.glb',
        (glb: GLTF) => {
          this._filledForkLiftmodelLane = glb.scene;
          this._filledForkLiftmodelLane.position.copy(position);
          this._filledForkLiftmodelLane.scale.copy(scale);
          this._filledForkLiftmodelLane.rotateY(Math.PI);
          this._filledForkLiftmodelLane.name = 'forkliftLane';
          glb.scene.traverse(function (child) {
            if ((<THREE.Mesh>child).isMesh) {
              child.castShadow = true;
              child.receiveShadow = true;
            }
          });
          this._models.push(this._filledForkLiftmodelLane);
        }
      );
      this._loaderGLTF.load(
        'assets/models/filledForklift.glb',
        (glb3: GLTF) => {
          this._filledForkLiftmodelExit = glb3.scene;
          this._filledForkLiftmodelExit.position.copy(position);
          this._filledForkLiftmodelExit.scale.copy(scale);
          this._filledForkLiftmodelExit.rotateY(rotation);
          this._filledForkLiftmodelExit.name = 'forkliftUntag';
          glb3.scene.traverse(function (child) {
            if ((<THREE.Mesh>child).isMesh) {
              child.castShadow = true;
              child.receiveShadow = true;
            }
          });
          this._models.push(this._filledForkLiftmodelExit);
        }
      );
      resolve();
    });
  }

  /** */
  /**
   * Sets monotainer Model on scene
   * @returns monotainer
   */
  setMonotainer(): Promise<void> {
    return new Promise((resolve) => {
      const scene = this._sceneService.getScene();
      this._loaderGLTF.load('assets/models/monotainer.glb', (glb: GLTF) => {
        this._monotainer = glb.scene;
        this._monotainer.scale.set(0.09, 0.09, 0.09);
        glb.scene.traverse(function (child) {
          if ((<THREE.Mesh>child).isMesh) {
            child.castShadow = true;
          }
        });
        this._monotainer.traverse((child) => {
          if (child instanceof THREE.Mesh) {
            child.material.emissive.setHex(0x5c4033);
          }
        });
        this._models.push(this._monotainer);
        resolve();
      });
    });
  }

  /**
   * Sets truck model
   */
  setTruck() {
    const scene = this._sceneService.getScene();
    this._loaderGLTF.load('assets/models/truckGreen.glb', (glb: GLTF) => {
      const truck = glb.scene;
      truck.position.set(12, 2.6, 3);
      truck.scale.set(0.7, 0.8, 1);
      truck.rotateY(Math.PI);
      glb.scene.traverse(function (child) {
        if ((<THREE.Mesh>child).isMesh) {
          child.castShadow = true;
        }
      });
      scene.add(truck);
      this._models.push(truck);
    });
  }

  /**
   * Sets cctv model
   */
  setCCTV() {
    const scene = this._sceneService.getScene();
    this._loaderGLTF.load('assets/models/CCTV.glb', (glb: GLTF) => {
      const cctv = glb.scene;
      cctv.position.set(1.9, 1.2, 7);
      cctv.scale.set(0.1, 0.1, 0.1);
      cctv.rotateY(Math.PI);
      glb.scene.traverse(function (child) {
        if ((<THREE.Mesh>child).isMesh) {
          child.castShadow = true;
        }
      });
      scene.add(cctv);
      this._models.push(cctv);
    });
  }

  setLaneName(res: any)
  {
    res.map((elem)=>{
      this._laneNames.push(elem.zoneName);
    });
  }

  getLaneName()
  {
    return this._laneNames;
  }

  /**
   * Sets lanes model based on api response
   */
  async setLanes() {
    const scene = this._sceneService.getScene();
    const masterPlanogramData = this._res;
    for (const element of masterPlanogramData) {
      await new Promise<void>((resolve) => {
        this._loaderGLTF.load('assets/models/LaneNew.glb', (glb: GLTF) => {
        const lane = glb.scene;
        lane.position.set((this._laneXPos += 1.6), 2.4, -1.5);
        lane.scale.set(0.13, 0.07, 0.11);
        //css3d lane Label
        const lanePoster = document.createElement('div');
        lanePoster.innerHTML = `
                <div class="alert alert-light" role="alert" style="width: 7rem; font-size: x-small; height: auto; padding: 5px; backface-visibility: hidden; --bs-alert-color: #535353; --bs-alert-bg: #d9d9d9;">
                    <h6 class="card-title" style="margin-bottom: 5px;">${element.zoneName}</h6>
                </div>
            `;
            lanePoster.style.textAlign='center';
        const lanePoster1 = lanePoster.cloneNode(true);
        //adds lane name on both sides
        const object = new CSS3DObject(lanePoster1 as HTMLElement);
        object.position.set(this._laneXPos +.1, this._modelPos.y+1.4, 4.5);
        object.scale.set(0.01, 0.01, 0.01);
        object.rotateY(2*Math.PI);
        object.name="left"
        this._laneName.push(object);
        //adds the bulb on top of lane
        const box1Geometry = new THREE.BoxGeometry(0.2, 0.2, 0.15);
        const material = new THREE.MeshPhysicalMaterial({
          roughness: 0,
          transmission: 0.6, // Add transparency
        });
        const stageBulb = new THREE.Mesh(box1Geometry, material);
        stageBulb.name = element.zoneName;
        stageBulb.position.set(this._laneXPos - 0.5, 4.3, 4.4);
        this._laneBulb.set(stageBulb.name, stageBulb);
        // Add the lane to the scene with a delay
          lane.name = element.zoneName;
          scene.add(lane);
          scene.add(stageBulb);
          scene.add(object);
          this._models.push(lane);
          resolve();
            });
    });
    };
    this._laneXPos = -2.4;
  }

  /**
   * Sets css billboard
   * @param res
   */
  setCssBillboard(res: any) {
    if (this._billBoard) {
      this._billBoard.removeFromParent();
      this._laneDetailsBillbord.forEach((child) => {
        child.removeFromParent();
        this._laneBillboardPos = 4.85;
        this._laneDetailsBillbord = [];
      });
    }
    const scene = this._sceneService.getScene();
    const lanePoster = document.createElement('div');
    lanePoster.innerHTML = `
    <div style="width: 100%; height: 100%; padding-left: 10px; background: #35343E; box-shadow: 1px 2px 15px rgba(255, 255, 255, 0.19) inset; border-radius: 5px; flex-direction: column; justify-content: flex-start; align-items: center; display: inline-flex">
    <div style="justify-content: center; align-items: baseline; gap: 25px; display: inline-flex">
        <div style="width: 89px; color: white; font-size: 16px; font-family: Inter; font-weight: 600; word-wrap: break-word">LANE</div>
        <div style="justify-content: center; align-items: baseline; display: flex">
            <div style="height: 49px; padding: 15px; border-left: 1px #393C49 solid; justify-content: center; align-items: baseline; display: flex">
                <div style="width: 95px; color: white; font-size: 16px; font-family: Inter; font-weight: 600; word-wrap: break-word">Active Tags</div>
            </div>
            <div style="height: 49px; padding: 15px; border-left: 1px #393C49 solid; justify-content: center; align-items: baseline; display: flex">
                <div style="width: 75px; color: white; font-size: 16px; font-family: Inter; font-weight: 600; word-wrap: break-word">Sort Area</div>
            </div>
            <div style="height: 49px; padding-top: 15px; padding-bottom: 15px; padding-left: 15px; padding-right: 10px; background: #367681; border-left: 1px #393C49 solid; justify-content: center; align-items: baseline; gap: 5px; display: flex">
                <div style="width: 60px; color: white; font-size: 16px; font-family: Inter; font-weight: 600; word-wrap: break-word">In Lane</div>
            </div>
            <div style="height: 49px; padding: 15px; border-left: 1px #393C49 solid; justify-content: center; align-items: baseline; gap: 5px; display: flex">
                <div style="width: 80px; color: white; font-size: 16px; font-family: Inter; font-weight: 600; word-wrap: break-word">Misplaced</div>
            </div>
            <div style="height: 49px; padding: 15px; border-left: 1px #393C49 solid; justify-content: center; align-items: baseline; gap: 5px; display: flex">
                <div style="width: 75px; color: white; font-size: 16px; font-family: Inter; font-weight: 600; word-wrap: break-word">Missing</div>
            </div>
            <div style="height: 49px; padding: 15px; border-left: 1px #393C49 solid; justify-content: center; align-items: baseline; gap: 5px; display: flex">
                <div style="width: 70px; color: white; font-size: 16px; font-family: Inter; font-weight: 600; word-wrap: break-word">Outside</div>
            </div>
        </div>
    </div>
</div>
            `;
    this._billBoard = new CSS3DObject(lanePoster);
    this._billBoard.position.set(8.5, this._laneBillboardPos, -3);
    this._billBoard.scale.set(0.008, 0.008, 0.008);
    this._billBoard.rotateY(Math.PI * 2);
    scene.add(this._billBoard);
    res.map((lane: any) => {
      const laneDetails = document.createElement('div');
      laneDetails.innerHTML = `
      <div style="width: 100%; height: 100%; padding-left: 10px; background: #1F1D2B; box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.17) inset; border-radius: 5px; border-top: 1px #393C49 solid; flex-direction: column; justify-content: flex-start; align-items: center; display: inline-flex">
    <div style="width: 740px; justify-content: center; align-items: baseline; gap: 25px; display: inline-flex">
        <div style="width: 32px; height: 32px; position: relative">
            <div style="width: 32px; height: 32px; padding: 4.57px; left: 0px; top: 0px; position: absolute; border-radius: 9.14px; justify-content: center; align-items: center; gap: 4.57px; display: inline-flex">
                <div style="width: 22.86px; height: 22.86px; position: relative">
                <img style="width: 18px; height: 17px; left: 1.5px; top: 2.14px; position: absolute" src="../../../assets/images/bellIcon.svg" />
              </div>
            </div>
            <div style="width: 10px; height: 10px; padding-left: 6.62px; padding-right: 6.62px; left: 16px; top: 2px; position: absolute; background: ${lane.alerts.length>0?"#EA3219":"#393C49"}; border-radius: 13.24px"></div>
        </div>
        <div style="width: 89px; color: white; font-size: 20px; font-family: Inter; font-weight: 700; word-wrap: break-word">${
          lane.zoneName}</div>
        <div style="justify-content: center; align-items: baseline; display: flex">
            <div style="height: 61px; padding: 15px; border-left: 1px #393C49 solid; justify-content: center; align-items: baseline; display: flex">
                <div style="width: 75px; color: white; font-size: 26px; font-family: Inter; font-weight: 600; word-wrap: break-word">${
                  lane.activeTags}</div>
            </div>
            <div style="height: 61px; padding: 15px; border-left: 1px #393C49 solid; justify-content: center; align-items: baseline; gap: 5px; display: flex">
                <div style="width: 95px; color: white; font-size: 26px; font-family: Inter; font-weight: 600; word-wrap: break-word">${
                  lane.waitingCount}</div>
            </div>
            <div style="height: 61px; padding: 15px; background: #195A65; justify-content: center; align-items: baseline; display: flex">
                <div style="width: 60px; color: white; font-size: 26px; font-family: Inter; font-weight: 600; word-wrap: break-word">${
                  lane.insideCount
                }</div>
            </div>
            <div style="height: 61px; padding: 15px; background: ${this._getColor(
              lane.mismatchCount,
              'mismatch'
            )}; border-left: 1px #393C49 solid; justify-content: center; align-items: baseline; gap: 5px; display: flex">
                <div style="width: 80px; color: white; font-size: 26px; font-family: Inter; font-weight: 600; word-wrap: break-word">${
                  lane.mismatchCount
                }</div>
            </div>
            <div style="height: 61px; padding: 15px; background: ${this._getColor(
              lane.missingCount,
              'missing'
            )}; border-left: 1px #393C49 solid; justify-content: center; align-items: baseline; gap: 5px; display: flex">
                <div style="width: 75px; color: white; font-size: 26px; font-family: Inter; font-weight: 600; word-wrap: break-word">${
                  lane.missingCount
                }</div>
            </div>
            <div style="height: 61px; padding: 15px; border-left: 1px #393C49 solid; justify-content: center; align-items: baseline; gap: 5px; display: flex">
                <div style="width: 70px; color: white; font-size: 26px; font-family: Inter; font-weight: 600; word-wrap: break-word">${
                  lane.outsideCount
                }</div>
            </div>
        </div>
    </div>
</div>
            `;
      this._laneDetailsBillbord.push(new CSS3DObject(laneDetails));
    });
    this._laneDetailsBillbord.forEach((laneBillboard) => {
      laneBillboard.position.set(8.5, (this._laneBillboardPos -= 0.4), -3);
      laneBillboard.scale.set(0.008, 0.008, 0.008);
      laneBillboard.renderOrder=Infinity;
      scene.add(laneBillboard);
    });
  }

  private _getColor(count: number, state: string): string {
    if (state == 'missing' && count > 0) {
      return '#F7C47582';
    } else if (state == 'mismatch' && count > 0) {
      return '#93342994';
    } else {
      return '#393C49';
    }
  }

  /**
   * Sets model load flag to check if all models are loaded completly
   * @param flag
   */
  setModelLoadFlag(flag: boolean) {
    this._flag = flag;
  }

  /**
   * Gets filled fork lift model
   * @returns filled fork lift model
   */
  getFilledForkLiftModel(): THREE.Group {
    return this._filledForkLiftModelSortArea;
  }

  /**
   * Gets filled fork lift model in lane
   * @returns filled fork lift model in lane
   */
  getFilledForkLiftModelInLane(): THREE.Group {
    return this._filledForkLiftmodelLane;
  }

  /**
   * Gets monotainer
   * @returns monotainer
   */
  getMonotainer(): THREE.Group {
    return this._monotainer;
  }

  /**
   * Gets filled fork lift model exit
   * @returns filled fork lift model exit
   */
  getFilledForkLiftModelExit(): THREE.Group {
    return this._filledForkLiftmodelExit;
  }

  /**
   * Gets mixer for animation
   * @returns mixer
   */
  getMixer(): THREE.AnimationMixer {
    return this._mixer;
  }

  /**
   * Gets all the loaded models
   * @returns models
   */
  getModels(): THREE.Object3D[] {
    return this._models;
  }

  /**
   * Gets glag to check if all models are loaded
   * @returns true if model load flag
   */
  getModelLoadFlag(): boolean {
    return this._flag;
  }

  /**
   * Gets lane bulb
   * @returns lane bulb
   */
  getLaneBulb(): Map<string, any> {
    return this._laneBulb;
  }
}
